import { groupBy } from 'ramda'
import { ReactElement } from 'react'

type ReactElementsByType = Record<string, ReactElement[]>

interface ReactElementWithDisplayName {
  type?: { displayName?: string }
}

export const groupReactElementsByDisplayName = (
  children: ReactElement[],
): ReactElementsByType =>
  groupBy(
    child => (child as ReactElementWithDisplayName).type?.displayName || '',
    children,
  )
